import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button_v2 as Button, Typography, TypographyVariantsEnum } from '@mindly/ui-components';
import { AppLogo } from '../../shared';

type DownloadAppFeatureProps = {
  inHeader?: boolean;
  onLoginClick?: () => void;
  onDownloadClick?: () => void;
};

const DownloadAppFeature: FC<DownloadAppFeatureProps> = ({ inHeader = false, onLoginClick, onDownloadClick }) => {
  const { t } = useTranslation('specialists');

  return (
    <div className={classNames('flex', { 'justify-between': inHeader }, { 'flex-col': !inHeader })}>
      {inHeader && <AppLogo width={34} height={34} />}
      <div
        className={classNames('flex items-center gap-2', {
          'flex-col items-center gap-5': !inHeader,
        })}
      >
        {!inHeader && (
          <Typography variant={TypographyVariantsEnum.Text24Semi} align={'center'}>
            {t('shared_profile.without_auth.title')}
          </Typography>
        )}
        <Button
          fill={'clear'}
          size={'small'}
          className={classNames({ 'order-last': !inHeader })}
          onClick={onLoginClick}
        >
          {t('shared_profile.without_auth.login_link')}
        </Button>
        <Button size={inHeader ? 'small' : 'default'} onClick={onDownloadClick}>
          {inHeader ? t('shared_profile.without_auth.open_app_button') : t('shared_profile.without_auth.app_button')}
        </Button>
      </div>
    </div>
  );
};

export default DownloadAppFeature;
